import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

// #region Sample data
const data = [
  {
    name: "03.10.2025",
    uv: 4000,
    // pv: 2400,
    // amt: 2400,
  },
  {
    name: "04.10.2025",
    uv: 3000,
    // pv: 1398,
    // amt: 2210,
  },
  {
    name: "05.10.2025",
    uv: -1000,
    // pv: 9800,
    // amt: 2290,
  },
  {
    name: "06.10.2025",
    uv: 500,
    // pv: 3908,
    // amt: 2000,
  },
  {
    name: "07.10.2025",
    uv: -2000,
    // pv: 4800,
    // amt: 2181,
  },
  {
    name: "08.10.2025",
    uv: -250,
    // pv: 3800,
    // amt: 2500,
  },
  {
    name: "09.10.2025",
    uv: 3490,
    // pv: 4300,
    // amt: 2100,
  },
];

// #endregion
const gradientOffset = () => {
  const dataMax = Math.max(...data.map((i) => i.uv));
  const dataMin = Math.min(...data.map((i) => i.uv));

  if (dataMax <= 0) {
    return 0;
  }
  if (dataMin >= 0) {
    return 1;
  }

  return dataMax / (dataMax - dataMin);
};

const off = gradientOffset();

const AreaChartFillByValueGraphic = () => {
  return (
    <div
      style={{
        width: "100%",
        height: "450px",

        backgroundColor: "var(--bcg)",
        marginLeft: "10px",
      }}
    >
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart
          style={{
            width: "100%",
            maxWidth: "600px",
            height: "50vh",
            minHeight: "300px",
            maxHeight: "400px",
            //   aspectRatio: 1.618,
          }}
          data={data}
          margin={{
            top: 10,
            right: 0,
            left: 0,
            bottom: 0,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis width={100} />
          <Tooltip />
          <defs>
            <linearGradient id="splitColor" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0" stopColor="blue" stopOpacity={1} />
              <stop offset={off} stopColor="blue" stopOpacity={0.1} />
              <stop offset={off} stopColor="orange" stopOpacity={0.1} />
              <stop offset="1" stopColor="orange" stopOpacity={1} />
            </linearGradient>
          </defs>
          <Area
            type="monotone"
            dataKey="uv"
            stroke="#000"
            fill="url(#splitColor)"
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default AreaChartFillByValueGraphic;
